import '~/scripts/integrations/jquery-extended';

$(document).on('turbo:load', function() {
  $(window).trigger('load.bs.select.data-api');
});
